import { NavLink } from "react-router-dom";
import "../../assets/css/pages/login/style.scss";
import cusBondLogo from "../../assets/images/common/header/bd-customs-logo-with-text.png";
import ErrorMessage from "../../components/ErrorMessage";
import ReCaptcha from "../../components/reCaptcha/reCaptcha";
import useLogin from "../../hooks/public/useLogin";

const Index = () => {
  const { register, handleSubmit, onSubmit, handleRecaptchaChange, errors } =
    useLogin();

  return (
    <main className="login-page">
      <div className="form-container">
        <div className="text-center">
          <img width="250" src={cusBondLogo} alt="cusBondLogo" />
          <h2 className="signIn-txt">Sign in</h2>
          <p className="subtext">to continue to CBMS Portal Admin</p>
        </div>
        <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form__div-container">
            <div className="form__div">
              <input
                autoFocus
                type="email"
                className="form__input"
                {...register("email")}
              />
              <label htmlFor="" className="form__label">
                Email
              </label>
            </div>
            {errors.email && <ErrorMessage message={errors.email.message} />}
          </div>
          <div className="form__div-container">
            <div className="form__div">
              <input
                type="password"
                className="form__input"
                {...register("password")}
              />
              <label htmlFor="" className="form__label">
                Password
              </label>
            </div>
            {errors.password && (
              <ErrorMessage message={errors.password.message} />
            )}
          </div>
          <div className="text-left pb-2">
            <a
              href="https://cusbond.gov.bd/forgot-password"
              className="reset-password-text"
            >
              <small style={{ fontWeight: 500, textDecoration: "none" }}>
                Forgot password?
              </small>
            </a>
          </div>
          <div className="mb-3 mt-1">
            <ReCaptcha onChange={handleRecaptchaChange} />
            {errors.recaptcha && (
              <ErrorMessage message={errors.recaptcha.message} />
            )}
          </div>
          <div className="text-left">
            <button type="submit" className="login-btn blue-btn">
              Login
            </button>
            <p className="mt-3 mb-0">
              <small>
                Back to&nbsp;
                <NavLink className="text-success font-weight-bold" to="/">
                  Portal
                </NavLink>
              </small>
            </p>
          </div>
        </form>
      </div>
    </main>
  );
};

export default Index;
